import { Component, Input, OnInit, signal, computed, DestroyRef, inject, } from "@angular/core";
import moment from "moment";
import constant from "../../../app.constant";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonHttpService } from "../../../utils/common-http.service";
import { LoaderService } from "../../../service/loaderService";
import { CommonModule } from "@angular/common";
import { EmptyStateComponent } from '../../../shared/components/empty-state/empty-state.component';

@Component({
  selector: "app-elefant-order-details",
  standalone: true,
  imports: [CommonModule, NgbModule, EmptyStateComponent],
  templateUrl: "./elefant-order-details.component.html",
  styleUrl: "./elefant-order-details.component.scss",
})
export class ElefantOrderDetailsComponent implements OnInit {
  //  Destroy Ref (Auto Cleanup)
  private destroyRef = inject(DestroyRef);

  @Input() orderData: any;

  orderItems = signal<any[]>([]);
  orderDetails = signal<any>(null);

  private filterItemsByCodeCount(codes: string[], collectionAt?: string): any[] {
    const codeCount: { [key: string]: number } = {};
    codes.forEach(code => { codeCount[code] = (codeCount[code] || 0) + 1; });
    const items = collectionAt ? this.orderItems().filter((i: any) => i?.collection_at === collectionAt) : this.orderItems();
    const usedCount: { [key: string]: number } = {};
    const result: any[] = [];
    for (const item of items) {
      const code = String(item?.item_code);
      if (codeCount[code] && (usedCount[code] || 0) < codeCount[code]) {
        result.push(item);
        usedCount[code] = (usedCount[code] || 0) + 1;
      }
    }
    return result;
  }

  pickupCollectedItems = computed(() => {
    const codes = this.orderDetails()?.pickup_collected_items ? String(this.orderDetails().pickup_collected_items).split(",") : [];
    return this.filterItemsByCodeCount(codes, 'Pickup');
  });

  deliveryCollectedItems = computed(() => {
    const codes = this.orderDetails()?.delivery_collected_items ? String(this.orderDetails().delivery_collected_items).split(",") : [];
    return this.filterItemsByCodeCount(codes, 'Delivery');
  });

  deliveredItems = computed(() => {
    const codes = this.orderDetails()?.delivered_items ? String(this.orderDetails().delivered_items).split(",") : [];
    return this.filterItemsByCodeCount(codes);
  });

  rtoDeliveryItems = computed(() => {
    const codes = this.orderDetails()?.rto_delivered_items ? String(this.orderDetails().rto_delivered_items).split(",") : [];
    return this.filterItemsByCodeCount(codes);
  });
  rtoDeliveredPickupItems = computed(() => {  return this.rtoDeliveryItems().filter( (item: any) => item?.collection_at === "Pickup");});
  rtoDeliveredDeliveryItems = computed(() => { return this.rtoDeliveryItems().filter( (item: any) => item?.collection_at === "Delivery");});
  wholePickupItems = computed(() => this.orderItems()?.filter( (item: any) => item?.collection_at == 'Pickup') ?? [] );
  wholeDeliveryItems = computed(() => this.orderItems()?.filter((item: any) => item?.collection_at == 'Delivery') ?? []);
  isLoading: boolean;

  constructor(public activeModal: NgbActiveModal, private http: CommonHttpService, private loader: LoaderService) { }

  ngOnInit(): void {
    this.getOrderItems(this.orderData?.orderType);
  }
  showLoader() {
    this.isLoading = true;  
    setTimeout(() => {
      this.isLoading = false;
    }, 400);
  }
  getOrderItems(orderType: string): void {
    this.loader.show();
    let url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.orderItems + `/${this.orderData?.orderId}`;
    if (orderType !== "live") { url = url + "?reqOrder=History"; }
    const sub = this.http.get(url).subscribe({
      next: (response: any) => {
        if (response?.status) {
          const items = orderType === "live" ? response?.data?.OrderItems : response?.data?.OrderItemDumps;
          this.orderDetails.set(response?.data);
          this.orderItems.set(items || []);
        }
        this.loader.hide();
      },
      error: () => {
        this.loader.hide();
      },
    });

    //  Auto Unsubscribe
    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }
}
